import {
    Component,
    Input,
    Output,
    OnInit,
    OnChanges,
    EventEmitter,
    ViewContainerRef,
    TemplateRef, 
    EmbeddedViewRef,
    ViewChild,
    ElementRef } from '@angular/core';

type OptionInterface = {label:string, value:string}
type SelectInterface = OptionInterface[];

@Component({
    selector: 'ng-common-virtual-scroll',
    templateUrl: './virtual-scroll.component.html',
    styleUrls: ['./virtual-scroll.component.scss']
})
export class VirtualScrollComponent implements OnInit, OnChanges {
    @ViewChild('topLevel') topLevel: ElementRef;

    @Input() currentOption;
    @Input() isDisabled: boolean
    @Input() options: SelectInterface = [];
    @Input() model: string;
    @Input() formName: string;
    @Input() formLabel: string;
    @Input() formValue: string = '';
    @Input() isRequired: boolean;
    @Output() modelChange = new EventEmitter();

    public view: EmbeddedViewRef<any>;
    public optionsCopy: SelectInterface = [];
    public isOpen: boolean = false;
    public button: {classes:string, style: string} = { classes: '', style: '' };
    constructor(private vcr: ViewContainerRef) {}

    ngOnInit() {
        if ((this.isRequired && !this.model) && !this.isDisabled) {
            this.formValue = 'Required'
        }
    }

    ngOnChanges() {
        if (this.options && this.optionsCopy.length !== this.options.length) {
            this.optionsCopy = this.options;
        }

        if (this.isRequired && !this.model) {
            this.formValue = 'Required';
            this.button.classes += ' ng-invalid'
        } else if (!this.isRequired && this.button.classes.indexOf('ng-invalid') !== -1) {
            this.button.classes = this.button.classes.replace('ng-invalid', '');
        }
    }

    search(event) {
        if (event.which !== 9 && event.which !== 13 && event.which !== 27 && 
            event.which !== 18 && event.which !== 32) {
            this.optionsCopy = this.options.filter(
                option => option.label.toLowerCase().includes(
                    event.target.value.toLowerCase())
                    );
        }

        if (this.optionsCopy.length === 1 && event.which !== 32) {
            this.modelChange.emit(this.optionsCopy[0]);
            this.formValue = this.optionsCopy[0].label;
        }
    }

    navigate(event) {
        if (event.which === 9 || event.which === 27) {
            setTimeout(() => {
                this.closeDropdown();
            }, 10)
        }
    }

    select(option: OptionInterface) {
        this.formValue = option.label;
        this.topLevel.nativeElement.querySelector('.focus-target').value = option.label;
        this.modelChange.emit(option.value);
        this.closeDropdown();
    }

    isActive(value: string) {    
        return value === this.model;
    }

    open(dropdownTpl: TemplateRef<any>) {
        if (!this.isOpen) {
            this.isOpen = true;
            this.view = this.vcr.createEmbeddedView(dropdownTpl);
            const dropdown = this.view.rootNodes[0];
            
            this.topLevel.nativeElement.appendChild(dropdown);
            
            setTimeout(()=> {
                this.topLevel.nativeElement.querySelector('.focus-target').focus();
            }, 100)
        }
    }

    closeDropdown(event?) {
        this.isOpen = false;

        if (this.view) {
            this.view.destroy();
        }
    }
}